export const calculateDisabledRanges = (
  genericInfo,
  allRowsData,
  rowId,
  formData
) => {
  const ranges = [];

  if (genericInfo) {
    ranges.push({
      start: new Date(genericInfo?.start_date),
      end: new Date(genericInfo?.end_date),
    });
  }

  if (formData) {
    ranges.push({
      start: new Date(formData?.["Info generali"]?.start_date),
      end: new Date(formData?.["Info generali"]?.end_date),
    });
  }

  Object.entries(allRowsData).forEach(([id, data]) => {
    if (id !== rowId && data.startDate && data.endDate) {
      ranges.push({
        start: new Date(data.startDate),
        end: new Date(data.endDate),
      });
    }
  });
  return ranges;
};

export const checkDateRangeOverlap = (startDate, endDate, disabledRanges) => {
  if (
    !startDate ||
    !endDate ||
    !disabledRanges ||
    disabledRanges.length === 0
  ) {
    return false;
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  return disabledRanges.some((range) => {
    return start <= range.end && end >= range.start;
  });
};

export const createRange = (startDate, endDate) => {
  return { start: startDate, end: endDate };
};

export const getRangesForRow = (currentRowId, genericInfo, allRowsData) => {
  const currentCulture =
    genericInfo?.field_colture?.[genericInfo?.field_colture?.length - 1];

  const genericInfoRange = [];

  if (currentCulture?.start_date && currentCulture.end_date) {
    genericInfoRange.push(
      createRange(
        new Date(currentCulture.start_date),
        new Date(currentCulture.end_date)
      )
    );
  } else if (genericInfo?.start_date && genericInfo?.end_date) {
    genericInfoRange.push(
      createRange(
        new Date(genericInfo.start_date),
        new Date(genericInfo.end_date)
      )
    );
  }
  return [
    ...genericInfoRange,
    ...Object.entries(allRowsData)
      .filter(
        ([rowId, data]) =>
          rowId !== currentRowId.toString() && data.start_date && data.end_date
      )
      .map(([, data]) =>
        createRange(new Date(data.start_date), new Date(data.end_date))
      ),
  ];
};
